import { createFileRoute } from "@tanstack/react-router";
import { RelatorioLitragemMensal } from "pages/relatorios/pages/litragem_mensal";

export const Route = createFileRoute("/a/relatorios/litragem-mensal")({
	component: RelatorioLitragemMensal,
});
